<template>
    <div class="bo-select-popup">
        <template v-if="!disabled">
            <div
                v-if="selectSingle"
                class="form-control bo-select-column cursor-pointer mw-100"
                :display-id="displayId"
                @click="active = true"
            >
                <span v-if="computedRecord">
                    <slot
                        name="bo_list_box_content"
                        :record="computedSelectedRecords"
                    >
                        <div class="d-inline-flex flex-nowrap overflow-hidden w-100">
                            <template v-if="!Object.values(computedSelectedRecords)?.length">
                                <span>{{ generalTranslations.select }}</span>
                            </template>
                            <template v-else>
                                <bo-list-box
                                    :items="
                                        Object.fromEntries(
                                            Object.values(computedSelectedRecords).map((attribute) => [
                                                attribute.name,
                                                true,
                                            ])
                                        )
                                    "
                                ></bo-list-box>
                            </template>
                        </div>
                    </slot>
                </span>
                <span
                    v-else-if="Object.values(initialRecords).length != 0 && Object.values(initialRecords)[0][displayId]"
                    :title="Object.values(initialRecords)[0][displayId]"
                >
                    {{ Object.values(initialRecords)[0][displayId] }}
                </span>
                <span
                    v-else-if="Object.values(initialRecords).length != 0 && Object.values(initialRecords)[0].full_name"
                    :title="Object.values(initialRecords)[0].full_name"
                >
                    {{ Object.values(initialRecords)[0].full_name }}
                </span>
                <span
                    v-else-if="Object.values(initialRecords).length != 0 && Object.values(initialRecords)[0].name"
                    :title="Object.values(initialRecords)[0].name"
                >
                    {{ Object.values(initialRecords)[0].name }}
                </span>
                <span v-else> {{ generalTranslations.select }} </span>
                <div>
                    <i class="icon-chevronright"></i>
                </div>
            </div>
            <div
                v-else-if="selectMultiple"
                class="form-control bo-select-column cursor-pointer"
                :display-id="displayId"
                @click="active = true"
            >
                <div v-if="Object.values(initialRecords).length != 0">
                    <bo-list-box :items="convertInitialRecordToDisplayId"></bo-list-box>
                </div>
                <span class="form-control-placeholder" v-else>{{ generalTranslations.select }}</span>
                <div>
                    <i class="icon-chevronright"></i>
                </div>
            </div>
        </template>

        <bo-popup-modal
            modalStyle="full-width full-height has-table popup-table"
            :active="active"
            :append-to-body="appendToBody"
            :no-title="true"
            @deactivate="active = false"
            @trigger="addRecords"
        >
            <template #body-content>
                <div class="table-content">
                    <bo-datatable-new
                        :select-multiple="selectMultiple"
                        :select-single="selectSingle"
                        :title="modalTitle"
                        :columns="convertArraytoObject"
                        :display-title-header="true"
                        :hide-refresh-button="hideRefreshButton"
                        :records="currentSelectedRecords"
                        :pagination="pagination"
                        :has-footer="true"
                        :stop-propagation="stopPropagation"
                        @select_multiple_records="selectRecord"
                        @selected_single_record="boDatatableSelectSingleRecord"
                        @mounted="fetchRecordsIfNeeded"
                        @get_data="fetchRecords"
                        @refresh_records="refreshRecords"
                        @modify="modifyPopupModalRecord"
                        :enable-view-selected-records="false"
                        :local-search-sort="localSearchSort"
                        :clear-selection-after-search="clearSelectionAfterSearch"
                        :clear-selection-after-sort="clearSelectionAfterSort"
                    >
                        <template #left_header_buttons>
                            <a
                                v-if="addNewRecordUrl"
                                :href="addNewRecordUrl"
                                class="btn btn-rounded arclight light"
                                target="_blank"
                            >
                                <i class="icon-add"></i>
                                <span>{{ generalTranslations.create ?? "Create" }}</span>
                            </a>
                        </template>
                        <template #trailing-slot>
                            <div>
                                <i
                                    class="icon-close cursor-pointer"
                                    @click="active = false"
                                ></i>
                            </div>
                        </template>
                    </bo-datatable-new>
                </div>
            </template>
        </bo-popup-modal>
    </div>
</template>

<script>
import Vue from "vue";
// import { boDatatableMixin } from "@/v2/mixins/bo-datatable.js";
import { boDatatableNewMixin } from "@/v2/mixins/bo-datatable-new.js";
import httpMixin from "@/v2/mixins/http.js";

Vue.component("bo-editable-button-popup", require("@/v2/components/bo-editable-button-popup.vue").default);
Vue.component("bo-popup-modal", require("@/v2/components/bo-popup-modal.vue").default);
Vue.component("bo-textarea-word-count", require("@/v2/components/bo-textarea-word-count").default);
Vue.component("bo-datatable-new", require("@/v2/components/bo-datatable-new.vue").default);
Vue.component("bo-list-box", require("@/v2/components/bo-list-box.vue").default);

export default {
    mixins: [boDatatableNewMixin, httpMixin],
    props: {
        // Teleport the popup modal to <body> so it is not trapped in a parent modal's stacking context
        appendToBody: {
            type: Boolean,
            default: false,
        },
        // NOT REACTIVE
        selectMultiple: {
            type: Boolean,
            default: true,
        },
        selectSingle: {
            type: Boolean,
            default: true,
        },
        columns: {
            type: Array,
            default: () => [],
        },
        customStyle: {
            type: String,
            default: "",
        },
        initialRecords: {
            // A contact with no roles is serialised as `roles: []` (an Array), a populated one
            // as an object keyed by id — so accept both shapes.
            type: [Object, Array],
            default: {},
        },
        computedRecord: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: true,
        },
        id: {
            type: String,
            default: "id",
        },
        title: {
            type: String,
            default: "Add Records",
        },

        modalTitle: {
            type: String,
            default: "Add Records",
        },
        url: {
            type: String,
            default: null,
        },
        getRecordsFn: {
            type: Function,
            default: null,
        },
        primaryKey: {
            type: String,
            default: "id",
        },
        displayId: {
            type: String,
            default: "full_name",
        },
        hideRefreshButton: {
            type: Boolean,
            default: true,
        },
        refreshRecordUrl: {
            type: String,
            default: null,
        },
        hideDisplayHeaderFilter: {
            type: Boolean,
            default: true,
        },
        addNewRecordUrl: {
            type: String,
            default: "",
        },
        addRecordsIntoFetchRecordPayload: {
            type: Boolean,
            default: false,
        },
        stopPropagation: {
            type: Boolean,
            default: false,
        },
        localSearchSort: {
            type: Boolean,
            default: false,
        },
        clearSelectionAfterSearch: {
            type: Boolean,
            default: true,
        },
        clearSelectionAfterSort: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            recordColumns: Object.assign({}, this.columns),
            records: null,
            pagination: {},
            selectedRecords: {},
            active: false,
            columnObject: {},
            generalTranslations: window.bo?.generalTranslations ?? {},
        };
    },
    computed: {
        computedSelectedRecords() {
            if ((!this.selectedRecords || Object.keys(this.selectedRecords).length === 0) && this.computedRecord) {
                const checkedRecord = Object.values(this.initialRecords).find((record) => record.checked === true);

                if (checkedRecord) {
                    this.selectedRecords = { [checkedRecord[this.primaryKey]]: checkedRecord };
                } else {
                    this.selectedRecords = {};
                }
            }
            return this.selectedRecords;
        },
        currentSelectedRecords() {
            let records = {};
            let selectedRecords = this.computedSelectedRecords;
            if (!selectedRecords || Object.keys(selectedRecords).length === 0) {
                selectedRecords = this.selectedRecords;
            }
            if (this.records != null) {
                Object.values(this.records).forEach((record) => {
                    records[record[this.primaryKey]] = record.copy ? record.copy() : { ...record };
                });
                Object.values(selectedRecords).forEach((selectedRecord) => {
                    if (this.records[selectedRecord[this.primaryKey]] != null) {
                        records[selectedRecord[this.primaryKey]].checked = true;
                    }
                });
            }
            return records;
        },
        convertArraytoObject() {
            if (this.computedRecord && Object.keys(this.columnObject).length > 0) {
                return this.columnObject;
            }
            if (Array.isArray(this.columns)) {
                this.columnObject = Object.assign({}, this.columns);
            } else {
                this.columnObject = this.columns;
            }
            return this.columnObject;
        },
        convertInitialRecordToDisplayId() {
            let records = {};
            let useFullName = false;
            let useName = false;
            let displayId = this.displayId;
            let selectedRecords = this.selectedRecords;

            if (Object.keys(selectedRecords).length == 0) {
                selectedRecords = this.initialRecords;
            }

            // Check displayId first
            Object.values(selectedRecords).forEach((record) => {
                if (!record[displayId]) {
                    useFullName = true;
                }
            });

            // Check full_name
            if (useFullName) {
                Object.values(selectedRecords).forEach((record) => {
                    if (!record.full_name) {
                        useFullName = false;
                        useName = true;
                    }
                });
            }

            Object.values(selectedRecords).forEach((record) => {
                let key;

                if (useName) {
                    key = record.name;
                } else if (useFullName) {
                    key = record.full_name;
                } else {
                    key = record[displayId];
                }

                if (key) {
                    records[key] = record;
                }
            });

            return records;
        },
    },
    methods: {
        boDatatableSelectSingleRecord(recordKey) {
            if (this.records[recordKey].checked) {
                this.$delete(this.selectedRecords, recordKey);
                this.records[recordKey].checked = !this.records[recordKey].checked;
            } else {
                Object.values(this.records).forEach((record) => {
                    if (record.checked) {
                        this.$delete(this.selectedRecords, record[this.primaryKey]);
                    }
                    record.checked = false;
                });
                this.records[recordKey].checked = true;
                if (this.selectedRecords.length != 0) {
                    for (const key in this.selectedRecords) {
                        this.$delete(this.selectedRecords, key);
                    }
                }

                this.$set(this.selectedRecords, recordKey, this.records[recordKey]);
            }
        },
        selectRecord(id, value) {
            this.boDatatableSelectRecord(this.records, id, value);
            if (!this.records[id].checked) {
                this.$delete(this.selectedRecords, id);
            } else {
                this.$set(this.selectedRecords, id, this.records[id]);
            }
        },
        addRecords() {
            if (this.editable) {
                if (this.computedRecord) {
                    this.$emit("trigger", this.records, this.id);
                } else {
                    this.$emit("trigger", this.selectedRecords, this.id);
                }
            }
        },
        fetchRecords(payload = null, success = null, failure = null) {
            if (this.computedRecord) {
                this.records = {};
                this.records = this.initialRecords;
            } else {
                if (!payload) {
                    payload = {};
                }
                payload.params = payload.params ?? {};
                if (this.addRecordsIntoFetchRecordPayload) {
                    payload.params.records = JSON.stringify(this.initialRecords);
                }
                this.boFetchRecords(
                    this.records,
                    this.pagination,
                    payload,
                    (records) => {
                        this.pagination = { ...this.pagination };
                        this.initializeRecords();
                    },
                    null,
                    this.url,
                    this.getRecordsFn
                );
            }
        },
        refreshRecords(payload = null, success = null, failure = null) {
            let url = this.refreshRecordUrl ?? this.url;
            if (!payload) {
                payload = {};
            }
            payload.params = payload.params ?? {};
            if (this.addRecordsIntoFetchRecordPayload) {
                payload.params.records = JSON.stringify(this.initialRecords);
            }
            this.boFetchRecords(
                this.records,
                this.pagination,
                payload,
                (records) => {
                    this.initializeRecords();
                },
                null,
                url,
                this.getRecordsFn
            );
        },
        fetchRecordsIfNeeded() {
            this.records = {};
            this.fetchRecords();
        },
        initializeRecords() {
            Object.values(this.records).forEach((record) => {
                record.checked = false;
                this.selectedRecords = {};
            });

            Object.entries(this.initialRecords).forEach(([id, initialRecord]) => {
                if (this.records[id] != null) {
                    this.records[id].checked = true;
                }

                this.$set(this.selectedRecords, id, initialRecord);
            });
        },
        modifyPopupModalRecord(id, columnKey, value) {
            Object.values(this.columnObject).forEach((column) => {
                if (column.id == columnKey) {
                    this.$set(this.records[id], columnKey, value);
                    if (id in this.selectedRecords) {
                        this.$set(this.selectedRecords[id], columnKey, value);
                    }
                }
            });
        },
    },
};
</script>
